import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faReact,
  faJs,
  faHtml5,
  faPhp,
  faCss3,
  faSass,
  faBootstrap,
  faNodeJs,
  faGit,
  faGithub,
  faAws,
} from "@fortawesome/free-brands-svg-icons";

import redux from "../images/skills/redux.svg";
import MySQLi from "../images/skills/mysql.svg";
import mongodb from "../images/skills/mongodb.svg";
import jquery from "../images/skills/jquery.svg";
import smarty from "../images/skills/smarty.png";
import tailwind from "../images/skills/tailwind.png";
import typescript from "../images/skills/typescript.svg";
import expressjs from "../images/skills/expressjs.svg";
import nestjs from "../images/skills/nestjs.svg";
import zustand from "../images/skills/zustand.png";
import postgress from "../images/skills/postgress.png";
import githubActions from "../images/skills/githubActions.png";
import graphql from "../images/skills/graphql.svg";
import redis from "../images/skills/redis.png";
import googleCloud from "../images/skills/gcp.png";
import nextjs from "../images/skills/nextjs.jpg";
export const skills = {
  HTML5: <FontAwesomeIcon icon={faHtml5} size="2x" />,
  CSS3: <FontAwesomeIcon icon={faCss3} size="2x" />,
  SASS: <FontAwesomeIcon icon={faSass} size="2x" />,
  Tailwind: (
    <img
      src={tailwind}
      style={{ height: "24px", width: "24px" }}
      alt={"tailwind"}
    />
  ),
  Boostrap: <FontAwesomeIcon icon={faBootstrap} size="2x" />,
  // Figma: <FontAwesomeIcon icon={faFigma} size="2x" />,
  Javascript: <FontAwesomeIcon icon={faJs} size="2x" />,
  Typecsript: (
    <img
      src={typescript}
      style={{ height: "35px", width: "35px" }}
      alt={"Typescript"}
    />
  ),
  JQuery: (
    <img
      src={jquery}
      style={{ height: "34px", width: "34px" }}
      alt={"JQuery"}
    />
  ),
  NodeJS: <FontAwesomeIcon icon={faNodeJs} size="2x" />,
  ExpressJs: (
    <img
      src={expressjs}
      style={{ height: "20px", width: "20px" }}
      alt={"ExpressJS"}
    />
  ),
  NestJs: (
    <img
      src={nestjs}
      style={{ height: "24px", width: "24px" }}
      alt={"NestJS"}
    />
  ),
  PHP: <FontAwesomeIcon icon={faPhp} size="2x" />,
  "PHP Smarty": (
    <img
      src={smarty}
      style={{ height: "24px", width: "24px" }}
      alt={"JQuery"}
    />
  ),
  GraphQL: (
    <img
      src={graphql}
      style={{ height: "24px", width: "24px" }}
      alt={"GraphQL"}
    />
  ),
  React: <FontAwesomeIcon icon={faReact} size="2x" />,
  NextJs: (
    <img
      src={nextjs}
      style={{ height: "20px", width: "20px" }}
      alt={"NextJS"}
    />
  ),
  Redux: (
    <img src={redux} style={{ height: "20px", width: "20px" }} alt={"redux"} />
  ),
  Zustand: (
    <img
      src={zustand}
      style={{ height: "24px", width: "auto" }}
      alt={"zustand"}
    />
  ),
  MongoDB: (
    <img
      src={mongodb}
      style={{ height: "24px", width: "24px" }}
      alt={"MongoDb"}
    />
  ),
  postgressSQL: (
    <img
      src={postgress}
      style={{ height: "24px", width: "24px" }}
      alt={"postgressSQL"}
    />
  ),
  MySQLi: (
    <img
      src={MySQLi}
      style={{ height: "24px", width: "24px" }}
      alt={"MySQLi"}
    />
  ),
  Redis: (
    <img src={redis} style={{ height: "24px", width: "24px" }} alt={"Redis"} />
  ),

  GIT: <FontAwesomeIcon icon={faGit} size="2x" />,
  GitHub: <FontAwesomeIcon icon={faGithub} size="2x" />,
  "GitHub Actions": (
    <img
      src={githubActions}
      style={{ height: "24px", width: "auto" }}
      alt={"GitHub Actions"}
    />
  ),
  AWS: <FontAwesomeIcon icon={faAws} size="2x" />,
  GoogleCloud: (
    <img
      src={googleCloud}
      style={{ height: "24px", width: "24px" }}
      alt={"GoogleCloud"}
    />
  ),
};
